import { Toggle, ToggleProps } from '@kcftech/design-system';
import { BaseInlineEditorProps, InlineEditor } from 'components/inline_edit/InlineEditor';
import { useInlineEditor } from 'custom_hooks/useInlineEditor';

const defaultRender = (value: boolean | undefined) => (value ? 'Yes' : 'No');

export type SwitchInlineEditorProps = BaseInlineEditorProps<boolean, boolean> &
    Readonly<{
        switchConfig?: Omit<ToggleProps, 'checked' | 'onChange'>;
    }>;

export function SwitchInlineEditor({
    value,
    renderValue = defaultRender,
    validate,
    onConfirm,
    onClose,
    isDisabled,
    editorClass,
    editorStyle,
    switchConfig,
    ariaLabel,
}: SwitchInlineEditorProps) {
    const {
        valueToRender,
        inputValue,
        error,
        setInputValue,
        isEditing,
        isConfirming,
        openEditor,
        closeEditor,
        confirm,
        canConfirm,
    } = useInlineEditor<boolean>({
        value,
        validate,
        onConfirm,
        onClose,
    });

    return (
        <InlineEditor
            ariaLabel={ariaLabel}
            value={renderValue(valueToRender)}
            editor={
                <Toggle
                    {...switchConfig}
                    checked={inputValue ?? false}
                    onChange={setInputValue}
                />
            }
            editorClass={editorClass}
            editorStyle={editorStyle}
            error={error}
            canClose={!isConfirming}
            canEdit={!isConfirming}
            canConfirm={canConfirm}
            isEditing={isEditing}
            isDisabled={isDisabled || isConfirming}
            isPending={isConfirming}
            onClose={closeEditor}
            onEdit={openEditor}
            onConfirm={confirm}
        />
    );
}
